import { Link, NavLink } from 'react-router-dom'
import { ShoppingCart } from 'lucide-react';  

export function Navigation({ onNavLinkClick }) {
   
  const getImagePath = (imageName) => {
    // Remove any leading slash from imageName
    const cleanImageName = imageName.replace(/^\//, '');
    return `${import.meta.env.BASE_URL}${cleanImageName}`;
  };
  
  return (
    <nav className="navbar navbar-expand-lg">       
      <NavLink className="navbar-brand mrs-saint-delafield-regular" to="/">
        <img src={getImagePath('img/fancyfleet-logo-white.png')} alt=""/>
      </NavLink>
      <button 
        className="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">             
            <li className="nav-item">
              <NavLink 
                to="/"
                onClick={onNavLinkClick}
                className={({ isActive }) => 
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/fleet"
                onClick={onNavLinkClick}
                className={({ isActive }) => 
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Fleet
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/about"
                onClick={onNavLinkClick}
                className={({ isActive }) => 
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/contact"
                onClick={onNavLinkClick}
                className={({ isActive }) => 
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Contact
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/faq"
                onClick={onNavLinkClick}
                className={({ isActive }) => 
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                FAQ
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/booking" className="text-dark btn-gold display-6 btn btn-md">Book Now</NavLink>
            </li>
            <li className="nav-item">
              <Link to={'tel:18589995287'} className="text-dark btn-gold display-6 btn btn-md">1-858-999-5287</Link>
            </li>
        </ul>
      </div> 
    </nav>
  )
}